module.exports = __webpack_public_path__ + "static/media/IMG_1670.e69edec4.JPG";